import { useMatchRoute, useNavigate } from "@tanstack/react-router";
import type * as React from "react";
import { useDispatch } from "react-redux";
import { CircleSpinner } from "react-spinners-kit";
import { useVersions } from "@/queries/useVersions";
import { type IDispatch, initEditState } from "@/state";

function VersionPicker() {
    const dispatch = useDispatch<IDispatch>();
    const navigate = useNavigate();
    const matchRoute = useMatchRoute();
    const match = matchRoute({ to: "/$version", fuzzy: true });
    const { data: versions = [], isPending } = useVersions();

    const changeVersion = (event: React.FormEvent<HTMLSelectElement>) => {
        const version = event.currentTarget.value;
        if (version) {
            navigate({
                to: "/$version",
                params: { version },
                search: (prev) => ({ langs: prev.langs }),
            });
            dispatch(initEditState(version));
        } else {
            navigate({ to: "/" });
        }
    };

    if (isPending) {
        return <CircleSpinner size={28} color="#666666" />;
    }

    const selectedVersion = match ? match.version : "";

    return (
        <select onChange={changeVersion} value={selectedVersion}>
            <option value="" key="">
                Select version
            </option>
            {[...versions].reverse().map((v) => (
                <option value={v} key={v}>
                    {v}
                </option>
            ))}
        </select>
    );
}

export default VersionPicker;
